import React, { useCallback } from "react";
import List from "@commonComponents/List";
import PaymentDetailForm from "@EUForms/paymentDetailForm";
import { useSelector } from "react-redux";
import { selectPaymentRoleList,selectPaymentTypeList } from "@EUForms/selectors";


const PaymentDetail = ({dataSource,...rest}) => {

 const paymentRoleList=useSelector(selectPaymentRoleList)
 const paymentTypeList=useSelector(selectPaymentTypeList)
 
 const validatePaymentType=(selectedPaymentType)=>dataSource.some(c=>c.paymentType==selectedPaymentType)
 

  const renderItem=useCallback((item,index)=> <PaymentDetailForm 
  dataSource={item} 
  key={item.id} 
  currentIndex={index}
  paymentRoleList={paymentRoleList}
  paymentTypeList={paymentTypeList}
  validatePaymentType={validatePaymentType}
  {...rest} />,[rest,paymentRoleList,paymentTypeList,validatePaymentType]
)

  
  return  <List className="responsiveGridCss" dataSource={dataSource} renderItem={renderItem} />
}

export default React.memo(PaymentDetail)
